// extracted by mini-css-extract-plugin
export var container = "_eg-1";
export var cornerButtonContainer = "_eg-6";
export var disabled = "_eg-2";
export var dragActive = "_eg-3";
export var fileContainer = "_eg-5";
export var hiddenInput = "_eg-4";
export var widthContainer = "_eg-0";